import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';
import { NotificationType } from '@leedpulse-monorepo/enums';
export default class Notifications {
  private _created: Date;
  private _id: string;
  private _idApiKey: string;
  private _idContact: string;
  private _type: NotificationType;
  private _updated: Date;
  private _days: number;

  constructor(
    created: Date,
    id: string,
    idApiKey: string,
    idContact: string,
    type: NotificationType,
    updated: Date,
    days: number
  ) {
    this._created = created;
    this._id = id;
    this._idApiKey = idApiKey;
    this._idContact = idContact;
    this._type = type;
    this._updated = updated;
    this._days = days;
  }

  get created(): Date {
    return this._created;
  }

  get id(): string {
    return this._id;
  }

  get idApiKey(): string {
    return this._idApiKey;
  }

  get idContact(): string {
    return this._idContact;
  }

  get type(): NotificationType {
    return this._type;
  }

  get updated(): Date {
    return this._updated;
  }

  get days(): number {
    return this._days;
  }

  static fromFirestore(
    data: QueryDocumentSnapshot<DocumentData, DocumentData>
  ): Notifications {
    const notificationData = data.data();
    return new Notifications(
      new Date(notificationData.created),
      data.id,
      notificationData.id_api_key,
      notificationData.id_contact,
      notificationData.type as NotificationType,
      new Date(notificationData.updated),
      notificationData.days
    );
  }

  // Copy with method
  public copyWith({
    created,
    id,
    idApiKey,
    idContact,
    type,
    updated,
    days,
  }: {
    created?: Date;
    id?: string;
    idApiKey?: string;
    idContact?: string;
    type?: NotificationType;
    updated?: Date;
    days?: number;
  }): Notifications {
    return new Notifications(
      created ?? this.created,
      id ?? this.id,
      idApiKey ?? this.idApiKey,
      idContact ?? this.idContact,
      type ?? this.type,
      updated ?? this.updated,
      days ?? this.days
    );
  }
}
